import { hasFeatureCanary } from '@citrite/workspace-ui-platform';
import { useConfigurationContext } from 'Configuration/useConfigurationContext';
import { FeatureFlag } from 'Environment/FeatureFlag';

export const useFeatureCanary = (featureFlag: FeatureFlag): boolean => {
	const { workspaceConfiguration } = useConfigurationContext();

	return hasFeatureCanary(workspaceConfiguration, featureFlag);
};

//allow-unused-export
export const useFeatureCanaryConfig = (featureFlag: FeatureFlag) => {
	const { featureCanaryConfiguration } = useConfigurationContext().configurationService;
	return featureCanaryConfiguration.isFeatureEnabled(featureFlag);
};
